// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2e320c52","453":"90b6259b","455":"5e1ccb6a","977":"95cb82c8"}[chunkId] + ".chunk.js";
};